import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES, FONTS } from 'src/constants'

interface IStyleProps {
  isOpen?: boolean
  iconMode?: string
}

const useStyles = makeStyles((theme: Theme) => ({
  sidebar: () => ({
    position: 'relative',
    zIndex: 1000,
    height: '100%',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [theme.breakpoints.down('laptop')]: {
      width: 200,

      marginTop: SPACES.xxxs,
      paddingLeft: SPACES.xxxxl,
      paddingRight: SPACES.xxxxl,
    },

    [theme.breakpoints.up('laptop')]: {
      paddingTop: SPACES.s,
      paddingLeft: SPACES.xxl,
      paddingRight: SPACES.xxl,
    },
  }),
  drawerPaper: {
    '&&': {
      borderRight: `solid 1px ${theme.palette.custom.grey}`,

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  iconHolder: ({ isOpen }: IStyleProps) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    marginTop: 16,
  }),
  iconLogo: ({ isOpen }: IStyleProps) => ({
    // maxHeight: isOpen ? '100px' : '60px',
    // minHeight: isOpen ? '60px' : '30px',
    maxWidth: isOpen ? '100px' : '60px',
    minWidth: isOpen ? '60px' : '40px',
    height: 'auto',
    width: '100%',
    borderRadius: 0,

    transition: 'all 0.3s ease-in-out',
  }),
  drawerButton: () => ({
    '&&': {
      padding: '12px',
      alignSelf: 'flex-start',
      marginTop: '24px',
    },
  }),
  bottomContainer: {
    paddingBottom: theme.spacing(2),

    [theme.breakpoints.down('laptop')]: {
      flexDirection: 'column',

      height: '100%',
      display: 'flex',
      justifyContent: 'end',
    },
  },
  link: ({ iconMode }) => ({
    '&&': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyItems: 'left',

      color: theme.palette.custom.darkBlue2,
      fontWeight: 700,
      fontSize: 14,
      textDecoration: 'none',

      cursor: 'pointer',
      transition: 'all 0.25s ease-in-out',

      '&:hover, &:focus': {
        color: theme.palette.custom.primary,

        '& svg > path': {
          fill: iconMode === 'stroke' ? 'none' : theme.palette.custom.primary,
        },
        '& svg': {
          stroke: iconMode === 'stroke' ? theme.palette.custom.primary : '',
        },
      },

      '& svg > path': {
        transition: 'all 0.25s ease-in-out',
      },

      [theme.breakpoints.down('laptop')]: {
        width: '10rem',
        padding: `${SPACES.m} ${SPACES.s}`,
      },
      [theme.breakpoints.up('laptop')]: {
        padding: SPACES.s,
      },
    },
  }),

  logoutLink: {
    color: 'white',
    textDecoration: 'none',

    '&:hover, &:focus': {
      color: theme.palette.custom.primary,

      '& svg path': {
        fill: theme.palette.custom.primary,
      },
    },

    '& svg > path': {
      transition: 'all 0.25s ease-in-out',
    },
  },
  titleWrapper: ({ isOpen }) => ({
    display: 'inline-flex',
    transition: isOpen ? 'opacity 0.25s cubic-bezier(1,.02,1,-0.63)' : '',
    opacity: isOpen ? '1' : '0',

    alignItems: 'center',

    margin: 0,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(0.3),

    whiteSpace: 'nowrap',
    textEllipsis: 'ellipsis',
    wordWrap: 'normal',
  }),
  countLoader: {
    marginLeft: SPACES.xxxs,
  },
  countBadge: {
    '&&': {
      marginLeft: SPACES.xxxs,
      height: '22px',
      backgroundColor: '#E57373',
      color: theme.palette.custom.white,
    },
  },
  image: ({ isOpen }: IStyleProps) => ({
    display: isOpen ? 'block' : 'none',

    minWidth: '8.75rem',
    minHeight: '2.625rem',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  }),

  imageSmall: ({ isOpen }: IStyleProps) => ({
    display: isOpen ? 'none' : 'block',

    margin: '16px auto',
    // marginTop: 21,
    // marginBottom: theme.spacing(2),
    // marginRight: 'auto',
    // marginLeft: '8px',

    width: 34,
    height: 'auto',
  }),

  versionWrapper: () => ({
    '&&': {
      width: '100%',
      [theme.breakpoints.down('laptop')]: {
        textAlign: 'left',
        paddingLeft: SPACES.s,
      },
      [theme.breakpoints.up('laptop')]: {
        textAlign: 'center',
      },
    },
  }),
  activeColor: {
    color: theme.palette.primary.main,
  },
  textWrapper: {
    padding: SPACES.xxs,
    textAlign: 'center',
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.semi_bold,
    },
  },
}))

export default useStyles
